<template>
  <div class="systemDictionaryList">
    <div class="dictionaryList">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="dictionaries"
          @setSelectedRow="setSelectedRow"
          @row-click="rowClick">
        <div slot="toolbar">
          <el-button v-if="addAuth" type="primary" @click="$refs.systemDictionaryEdit.open()"> 新建 </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="字典名称：">
              <el-input v-model.trim="filter.dictionaryName" placeholder="请输入字典名称" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column align="center" width="55" type="radio" prop="selection">
          <template slot-scope="scope">
            <el-radio v-model="currentRowIndex" :label="scope.$index" @change="selectedRow(scope.row, scope.$index)"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="dictionaryName"
            min-width="100"
            show-overflow-tooltip
            align="left"
            label="字典名称"/>
        <el-table-column
            prop="dictionaryNo"
            min-width="180"
            show-overflow-tooltip
            align="left"
            label="字典编码"/>
        <el-table-column label="操作" align="center" width="120" prop="action">
          <template slot-scope="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.systemDictionaryEdit.open(scope.row)"> 编辑 </el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteDictionary(scope.row.pkid)"> 删除 </el-button>
          </template>
        </el-table-column>
      </vm-table>
    </div>
    <div class="dictionaryContent">
      <vm-table
          ref="vmTable2"
          module="basic"
          :filter.sync="filter1"
          :url="'dictionaries/' + selectedDictionaryId"
          @select="selectHandler"
          @select-all="selectHandler">
        <div slot="toolbar">
          <el-button v-if="addAuth" type="primary" @click="$refs.systemDictionaryInfoEdit.open()"> 新建 </el-button>
          <el-button v-if="(selection.length > 0 && delAuth)" type="danger" @click="deleteBatch"> 批量删除 </el-button>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="数据名称：">
              <el-input v-model.trim="filter1.filter" placeholder="请输入名称" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column type="selection" width="55" align="center" prop="selection"/>
        <el-table-column
            prop="itemName"
            show-overflow-tooltip
            align="left"
            label="数据名称"/>
        <el-table-column prop="itemId" align="center" width="80" label="数据值"/>
        <el-table-column label="操作" align="center" width="120" prop="action">
          <template slot-scope="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.systemDictionaryInfoEdit.open(scope.row)"> 编辑 </el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteDictionaryInfo(scope.row.pkid)"> 删除 </el-button>
          </template>
        </el-table-column>
      </vm-table>
    </div>
    <!-- 字典列表edit -->
    <system-dictionary-edit ref="systemDictionaryEdit" @save-success="getList(1)"/>

    <!-- 字典配置edit -->
    <system-dictionary-info-edit ref="systemDictionaryInfoEdit" :master-id="selectedDictionaryId" @save-success="getDictionaryInfoById(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import SystemDictionaryEdit from "./SystemDictionaryEdit.vue";
  import SystemDictionaryInfoEdit from "./SystemDictionaryInfoEdit.vue";
  export default {
    components: {
      VmTable,
      VmSearch,
      SystemDictionaryEdit,
      SystemDictionaryInfoEdit,
    },

    data() {
      return {
        addAuth: this.$auth(271),
        editAuth: this.$auth(272),
        delAuth: this.$auth(273),
        currentRowIndex: "",
        selectedDictionaryId: "",
        selection: [],
        filter: {
          dictionaryName: "",
        },
        filter1: {
          filter: "",
        },
      };
    },

    watch: {
      selectedDictionaryId: {
        handler(val) {
          console.log(val);
          if (val) {
            this.selectedDictionaryId = val;
            this.$nextTick(() => {
              this.getDictionaryInfoById(1);
            });
          }
        },
      },
    },

    mounted() {
      this.getList(1);
    },

    methods: {
      // 查询字典列表
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      // 删除字典
      deleteDictionary(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "dictionaries", pkid).then((resp) => {
            if (resp.success) {
              this.$message.success("删除成功");
              this.getList(1);
            }
          });
        });
      },

      // 根据字典id查询配置信息
      getDictionaryInfoById(pageNum) {
        this.$refs.vmTable2.getList(pageNum);
      },

      // 删除字典配置
      deleteDictionaryInfo(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "dictionaries/item", pkid).then((resp) => {
            if (resp.success) {
              this.$message.success("删除成功");
              this.getDictionaryInfoById(1);
            }
          });
        });
      },

      // checkBox
      selectHandler(selection) {
        this.selection = selection;
      },

      // 批量删除
      deleteBatch() {
        var ids = [];
        this.selection.forEach(item => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "dictionaries/item/batchDelete",ids).then((resp) => {
            if (resp.success) {
              this.$message.success("删除成功");
              this.getDictionaryInfoById(1);
              this.selection = [];
            }
          });
        });
      },

      rowClick(row) {
        const tableData = this.$refs.vmTable.tableData;
        tableData.forEach((item, index) => {
          if (item.pkid === row.pkid) {
            this.currentRowIndex = index;
            this.selectedDictionaryId = row.pkid;
          }
        });
      },

      selectedRow(row, index) {
        this.currentRowIndex = index;
        this.selectedDictionaryId = row.pkid;
      },

      setSelectedRow(val) {
        this.rowClick(val);
      },
    },
  };
</script>
<style scoped>
.systemDictionaryList {
  overflow: hidden;
}

.dictionaryList {
  width: 55%;
  float: left;
}

.dictionaryContent {
  width: 43%;
  float: right;
}
</style>
